<template>
  <NuxtLoadingIndicator color="var(--primary-2)" />
  <Html :dir="head.htmlAttrs.dir">
    <LayoutTheHeader
      is-template4
      :route-path="routePath"
      @open-login="openLogin"
    />
    <Auth ref="authRef">
      <template #googleSignin>
        <google />
      </template>
    </Auth>
    <main :class="{ 'pt-[3.75rem]': !isHome }">
      <slot />
    </main>
    <LazyLayoutTheFooterOneFour />
    <slot name="whats-app">
      <LazyLayoutWhatsappFloatButtonPicker :raised="isProductPage" />
    </slot>
  </Html>
</template>

<script setup lang="ts">
const authRef = ref<any>(null);

onMounted(() => {
  const addCloseBtn = (popup: Element) => {
    if (popup.querySelector(".cw-close-btn")) return;
    const btn = document.createElement("button");
    btn.className = "cw-close-btn";
    btn.setAttribute("aria-label", "Close");
    btn.innerHTML = "&times;";
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      (popup as HTMLElement).style.display = "none";
    });
    (popup as HTMLElement).style.position = "relative";
    popup.appendChild(btn);
  };

  const tryInject = () => {
    const chatContainer = document.querySelector(".chat-container");
    if (!chatContainer) return;
    const popup = chatContainer.querySelector<Element>(
      '[class*="bubble"], [class*="tooltip"], [class*="popup"], [class*="preview"], [class*="teaser"]',
    );
    if (popup) addCloseBtn(popup);
  };

  const observer = new MutationObserver(tryInject);
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(tryInject, 3000);
});
const head = useI18nHead();
useHead({
  link: [
    // Chat-widget CSS (and the Kinetika font it @imports) is non-critical — it
    // styles a widget that only appears after load. Load it without blocking the
    // initial render: apply as print, then swap to all once fetched.
    {
      rel: "stylesheet",
      href: "https://365adventures-widget.balticai.ee/style.css",
      media: "print",
      onload: "this.media='all'",
    },
  ],
  script: [
    {
      type: "module",
      src: "https://365adventures-widget.balticai.ee/chat-widget.js",
      tagPosition: "bodyClose",
    },
  ],
});

function openLogin() {
  authRef.value.open();
}
provide("openLogin", openLogin);
const localePath = useLocalePath();
const route = useRoute();
const routePath = ref(route.path);
const isProductPage = useIsProductPage();

const isHome = ref(true);

watch(
  () => route.path,
  () => {
    routePath.value = route.path;
    isHome.value = route.path == localePath("/");
  },
  { immediate: true },
);
</script>

<style>
.chat-container {
  bottom: 5rem !important;
  @media screen and (max-width: 767px) {
    bottom: 4.2rem !important;
  }
}

.cw-close-btn {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.18);
  color: #fff;
  font-size: 12px;
  line-height: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: 0;
  transition: background 0.2s;
}

.cw-close-btn:hover {
  background: rgba(0, 0, 0, 0.35);
}
</style>
